<template>
  <div class="bmwFormLayout">
    <dropdown-list
      v-model="formData.carModel"
      :is-invalid="$v.formData.carModel.$error"
      :label="__('Vehicle of interest')"
      :valueList="carModelList"
      :errorMsg="$v.formData.carModel.$error ? errorMessages.carModel : null"
    />
    <div class="paragraph">{{__('How would you like to discover your new BMW? (Select up to two)')}}</div>

    <input-checkbox test-id="checkbox-testDrive" v-model="formData.testDrive" :label="__('Take a test drive')" />

    <input-checkbox test-id="checkbox-getBrochure" v-model="formData.getBrochure" :label="__('Get a brochure')" />

    <input-checkbox
     test-id="checkbox-contactRequest"
      v-model="formData.contactRequest"
      :is-invalid="$v.formData.contactRequest.$error"
      :label="__('Request for contact')"
      :errorMsg="$v.formData.contactRequest.$error ? errorMessages.discoverMethod : null"
    />

    <div class="paragraph">{{__('My consent to advertising communication.')}}</div>

    <div
      class="paragraph"
    >{{__('After registration we will only contact you about participation in the BMW xDrive Cup contest. However we would like to keep you informed of our latest events, news and other projects that may be of interest.')}}</div>

    <div class="paragraph">
      <input-checkbox
        test-id="checkbox-emailCommunication"
        v-model="formData.emailCommunication"
        :infoText="(isUSA)?__('I am an US consumer and direct Bayerische Motoren Werke AG to disclose my contact information to BMW of North America, LLC so that I may receive information about US products and services. I understand that Bayerische Motoren Werke AG will not communicate directly with me.'):__('Info icon agree BMW AG')"
        :label="__('I would like to receive advertising communication from BMW via email')"
      />
    </div>

    <div class="paragraph" v-if="!isUSA">
      {{__('Request for changes to the declaration of consent.')}}
      <info :infoText="__('Info icon request for changes')" />
    </div>

    <input type="hidden" id="bmwData" name="bmwData" v-model="bmvData" />
    <button type="button" id="verifyBmwForm" @click="verify" hidden>Verify</button>
  </div>
</template>

<script>
import DropdownList from "./layout/DropdownList";
import Info from "./layout/Info";
import InputCheckbox from "./layout/InputCheckbox";
import BMWMixin from "./BMWMixin";
import axios from "axios";

export default {
  name: "BmwForm",
  mixins: [BMWMixin],
  components: { DropdownList, InputCheckbox, Info },
  data() {
    return {
      formData: {
        carModel: null,
        testDrive: null,
        getBrochure: null,
        contactRequest: null,
        emailCommunication: null
      },
      carModelList: null,
      bmvData: null,
      userCountry: ""
    };
  },
  async mounted() {
    let q = this.$router.currentRoute.query;
    
    if(q.country)
      this.userCountry = q.country;
    
    //set user language http://localhost:4545/?lang=de
    this.__setLanguage(q.lang);

    //fill car model list, default language is EN. Only in case of lang=de use german list, in other cases use EN
    let lang_models = "en";
    if (q.lang && "de" === q.lang.toLowerCase()) lang_models = "de";
    const responce = await axios.get(
      "./models/models_{0}.json".format(lang_models)
    );
    this.carModelList = responce.data;
  },
  created: function() {
    // ('on Form bmw creation');
    window.addEventListener("message", event => {
     // eslint-disable-next-line no-undef
     // IMPORTANT: check the origin of the data!
      // eslint-disable-next-line no-undef
      if (event.origin.startsWith(config.PORTAL_URL) || event.origin.startsWith('http://localhost:8080')) {
        // The data was sent from your site.
        // Data sent with postMessage is stored in event.data:
        if (event.data && event.data == "verify") {
          this.verify();
        }
      } else {
        // The data was NOT sent from your site!
        // in case it was attempt to call "verify" write info in console
        if (event.data && event.data == "verify")
         console.log("Host " +  event.origin + " is not allowed to validate bmw-form. This host must be added to configuration!");
        return;
      }
    });
  },
  /* destroyed: function() {
    window.removeEventListener("message", this.move);
  },*/
  computed: {
    errorMessages() {
      return {
        carModel: this.__("Please, select your vehicle of interest"),
        discoverMethod: this.__("Please, select up to two checkboxes"),
      };
    },
    isUSA(){
      if(this.userCountry.toUpperCase() =='US')
       return true;
      return false; 
    }

  },
  methods: {
    verify() {
      this.$v.$touch();
      if (!this.$v.formData.$error) {
        this.bmvData = JSON.stringify(this.formData);
      } else this.bmvData = null;
      if (this.bmvData) 
        parent.postMessage(this.bmvData, "*");
    
    },
    validateDiscoverMethods() {
      var calcDiscover = 0;
      var discoverMethods = [this.formData.testDrive, this.formData.getBrochure, this.formData.contactRequest];
      discoverMethods.forEach((item)=>{if(item)calcDiscover++;});
    
      if (calcDiscover>0 && calcDiscover<3) {
            return true;
      }
        return false;
    }

  },
  validations: {
    formData: {
      carModel: {
        carModel(value) {
          if (value) {
            return true;
          }
          return false;
        }
      },
      contactRequest: {
        contactRequest() {
          return this.validateDiscoverMethods();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
.bmwFormLayout {
  padding: 1em;
}

.paragraph {
  margin-top: 1em;
}
</style>
